import actions from 'actions';
import { store } from 'index.js';
import api from 'api';

export default {

  PARTICIPANT_LOGIN_SUCCESS: 'PARTICIPANT_LOGIN_SUCCESS',
  PARTICIPANT_LOGOUT_SUCCESS: 'PARTICIPANT_LOGOUT_SUCCESS',
  RECEIVE_PARTICIPANT: 'RECEIVE_PARTICIPANT',
  SET_PARTICIPANT_TRIAL: 'SET_PARTICIPANT_TRIAL',
  START_LOADING_PARTICIPANT_TRIAL: 'START_LOADING_PARTICIPANT_TRIAL',
  STOP_LOADING_PARTICIPANT_TRIAL: 'STOP_LOADING_PARTICIPANT_TRIAL',
  COMPLETE_STAGE: 'COMPLETE_STAGE',
  RECEIVE_AGREEMENTS: 'RECEIVE_AGREEMENTS',

  receiveLogin(token) {
    store.dispatch(this.startLoadingTrial());
    api.participants.me(data => {
      store.dispatch(actions.trials.receiveTrial(data.ownerTrial));
      store.dispatch(actions.teams.receiveTeam(data.ownerTeam));
      store.dispatch(this.receiveParticipant(data));
    }, err => store.dispatch(this.stopLoadingTrial(err)));
    return { type: this.PARTICIPANT_LOGIN_SUCCESS, token };
  },

  logout() {
    return { type: this.PARTICIPANT_LOGOUT_SUCCESS };
  },

  receiveParticipant(participant) {
    return { type: this.RECEIVE_PARTICIPANT, participant };
  },

  startLoadingTrial() {
    return { type: this.START_LOADING_PARTICIPANT_TRIAL };
  },
  stopLoadingTrial(err) {
    return { type: this.STOP_LOADING_PARTICIPANT_TRIAL, error: err };
  },
  completeStage(id, stage) {
    return { type: this.COMPLETE_STAGE, id, stage };
  },
  receiveAgreements(id, agreements) {
    return { type: this.RECEIVE_AGREEMENTS, id, agreements };
  },
};
